import styled from '@emotion/styled';
import { ICON_COLORS } from 'Style/colors';

export const Meatball = styled.div(({ highlight }) => ({
  height: '3px',
  width: '3px',
  borderRadius: '50%',
  backgroundColor: `${highlight ? ICON_COLORS.overlay : ICON_COLORS.base}`,
}));
